const NA_SCORE = 'n/a';

export const getClassNameByScore = (actual, total) => {
    const percentage = actual / total * 100;
    return isNA(actual) ? "na-score" : percentage >= 66 ? 'positive' : percentage >= 33 ? 'neutral' : 'negative';
}

export const getClassNameContainerByScore = (actual, total) => {
    const percentage = actual / total * 100;
    return isNA(actual) ? "na-score-container" : percentage >= 66 ? 'positive-container' : percentage >= 33 ? 'neutral-container' : 'negative-container';
}

export const FACTOR_TITLES = {
    COMMUNICATION_AND_INTELLIGENCE: "Communication & Engagement",
    FORWARD_INTELLIGENCE: "Forward Motion",
    QUESTION_HANDLING: "Question Handling",
    SALES_PROCESS: "Sales Process"
}

export const QUESTIONS = {
    WHAT_WORKED: "What worked ?",
    WHAT_DID_NOT_WORK: "What did not work ?",
    HOW_COULD_IT_BE_IMPROVED: "How could it be improved ?"
}

export const isNA = (score) => {return score?.toString().toLowerCase() === NA_SCORE};